<template>
	<div v-if="!loading">
		<div v-for="(folders, serviceId) in remoteObjects" :key="serviceId">
			<div class="my-3 d-flex justify-content-between pt-3">
				<h3>{{ serviceId }}</h3>
				<div class="d-flex" style="gap: 1em;">
					<button class="btn btn-secondary btn-compact" :disabled="isSelectAllDisabled(serviceId)" type="button" @click="selectOrDeselectAllByService(true, serviceId)">Select All</button>
					<button class="btn btn-secondary btn-compact" :disabled="isDeselectAllDisabled(serviceId)" type="button" @click="selectOrDeselectAllByService(false, serviceId)">Deselect All</button>
				</div>
			</div>
			
			<div v-for="folder in folders" :key="folder.name" class="accordion" role="tablist">
				<div class="accordion-header">
					<div class="d-flex justify-content-between align-items-center col-12 mb-0">
						<h5>{{getObjectTypeTitle(folder.name)}}</h5>
						<div class="my-2">
							<button class="btn btn-secondary btn-compact" :disabled="isSelectAllDisabled(serviceId, folder)" type="button" @click="selectOrDeselectAll(true, serviceId, folder)">Select All</button>
							<button class="btn btn-secondary btn-compact" :disabled="isDeselectAllDisabled(serviceId, folder)" type="button" @click="selectOrDeselectAll(false, serviceId, folder)">Deselect All</button>
							<b-button v-b-toggle="'accordion-' + serviceId + '-' + folder.name" variant="compact">
								<i class="when-open fas fa-chevron-up"></i>
								<i class="when-closed fas fa-chevron-down"></i>
							</b-button>
						</div>
					</div>
				</div>
				<b-collapse :id="'accordion-' + serviceId + '-' + folder.name" class="accordion-body" accordion="my-accordion" role="tabpanel">

					<table class="table">
						<thead>
							<tr>
								<th scope="col">#</th>
								<th scope="col">Name</th>
								<th scope="col">Folder</th>
								<th scope="col">Last Commit</th>
								<th scope="col">Last Update</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(file, index) in folder.files" :key="index">
								<td>{{ index + 1 }}</td>
								<td><b-form-checkbox v-model="selected[serviceId][file.filePath]" @change="onChange(serviceId, folder, file, $event)">{{file.name}}</b-form-checkbox> </td>
								<td>{{file.folderPath}}</td>
								<td>{{file.commitSha}}</td>
								<td>{{file.lastModified}}</td>
							</tr>
						</tbody>
					</table>

				</b-collapse>
			</div>

		</div>
		<div v-if="remoteObjects == null" class="mb-5">
			<NoData  />
		</div>
		<div class="d-flex justify-content-between align-items-center pb-5 pt-3">
			<button class="btn btn-secondary" type="button" @click="onBack()">Back</button>
			<button class="btn btn-primary" type="button" @click="onNext()">Next</button>
		</div>
	</div>
</template>

<script>
import NoData from '../shared/NoData';

export default {
	name: "Manifest",
	props: ['remoteObjects'],
	components: {
		NoData
	},
	data() {
		return {
			selected: {},
			loading: true
		};
	},
	mounted() {
		this.loading = true;
		this.setupSelectionLists();
	},
	methods: {
		setupSelectionLists() {
			const selected = Object.assign({}, this.selected);
			Object.entries(this.remoteObjects).forEach(([serviceId, folders]) => {
				const selectedByService = {};
				for (const rootFolder of folders) {
					for (const file of rootFolder.files) {
						selectedByService[file.filePath] = true;
					}
					selectedByService[rootFolder.name + '-someSelected'] = true;
					selectedByService[rootFolder.name + '-allSelected'] = true;
				}
				selected[serviceId] = selectedByService;
				selected[serviceId + '-someSelected'] = true;
				selected[serviceId + '-allSelected'] = true;				
			});

			this.selected = selected;
			this.loading = false;
		},
		selectOrDeselectAll(val, serviceId, folder) {
			const selected = Object.assign({}, this.selected);
			for (const file of folder.files){
				selected[serviceId][file.filePath] = val;
			}
			this.selected = selected;
			this.updateAllSelectedFlag(serviceId);
		},
		selectOrDeselectAllByService(val, serviceId) {
			for (const folder of this.remoteObjects[serviceId]) {
				this.selectOrDeselectAll(val, serviceId, folder);
			}
			this.updateAllSelectedFlag(serviceId);
		},
		onNext() {
			this.$emit("next", this.selected);
		},
		onBack() {
			this.$emit("back");
		},
		getObjectTypeTitle (name) {
			return name.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toUpperCase();
		},
		onChange(serviceId, folder, file, value) {
			this.selected[serviceId][file.filePath] = value;
			this.updateAllSelectedFlag(serviceId);
		},
		updateAllSelectedFlag(serviceId) {
			let allSelected = true;
			let someSelected = false;
			for (const folder of this.remoteObjects[serviceId]) {
				const countSelected = folder.files
										.filter((file) => this.selected[serviceId][file.filePath])
										.length;
				this.selected[serviceId][folder.name + '-someSelected'] = countSelected > 0;
				this.selected[serviceId][folder.name + '-allSelected'] = countSelected === folder.files.length;
				if (countSelected > 0) someSelected = true;
				if (countSelected < folder.files.length) allSelected = false;
			}

			this.selected[serviceId + '-someSelected'] = someSelected;
			this.selected[serviceId + '-allSelected'] = allSelected;
		},
		isSelectAllDisabled(serviceId, folder) {
			return folder == null ? this.selected[serviceId + '-allSelected'] : this.selected[serviceId][folder.name + '-allSelected'];
		},
		isDeselectAllDisabled(serviceId, folder) {
			return !(folder == null ? this.selected[serviceId + '-someSelected'] : this.selected[serviceId][folder.name + '-someSelected']);
		}
	}
};
</script>

<style scoped>

</style>